import React from 'react'
import WizTableForm from '@/containers/common/wizTableForm/wizTableForm'
import { mergeColumns } from './utils';
const organizationConfig = WizTableForm.Config.organizationBrandNode(this, { apiParams: { state: 1, organizationNodeCategory: [2] } })

//配置项
let componentName = 'certificateStatistics'

function columns() {
  let columns = [
    {
      name: 'id',
      dataIndex: 'id',
      formItem: {
        type: 'hidden'
      }
    },
    {
      title: '品牌',
      name: 'brandId',
      dataIndex: 'brandId',
      searchItem: {
        ...organizationConfig,
        diy: WizTableForm,
        selectType: 'radio',
        rules: [{ required: true, message: '请选择品牌' }]
      }
    },
    {
      title: '经销商名称',
      name: 'searchOrgName',
      dataIndex: 'searchOrgName',
      searchItem: {}
    },
    {
      title: '经销商名称',
      name: 'orgName',
      dataIndex: 'orgName',
      tableItem: {}
    },
    {
      title: '组织编码',
      name: 'searchOrgCode',
      dataIndex: 'searchOrgCode',
      searchItem: {}
    },
    {
      title: '销售代码',
      name: 'preSalesNumber',
      dataIndex: 'preSalesNumber',
      tableItem: {}
    },
    {
      title: '售后代码',
      name: 'afterSalesNumber',
      dataIndex: 'afterSalesNumber',
      tableItem: {}
    },
    {
      title: '品牌',
      name: 'brandName',
      dataIndex: 'brandName',
      tableItem: {}
    }
  ]
  return mergeColumns.call(this, columns, [])
}

function templateConfig() {
  return {
    mainProps: {},
    content: {
      name: 'WizTableList',
      params: {
        columns: columns.call(this),
        searchBarProps: {
          buttonSort: ['export'],
          buttons: [
            {
              key: 'export',
              custom: true,
              params: { icon: 'export', children: '导出', type: 'export' },
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: 'export',
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return { ...filters }
                }
              }
            }
          ],
          collapse: false,
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: (record, index) => index,
          isScroll: true,
          bordered: true,
          loading: false
        }
      }
    }
  }
}

const apis = {
  list: {
    path: `${componentName}/list`,
    payload: {
      key: `${componentName}@list`,
      apiParams: {}
    }
  },
  export: {
    path: `${componentName}/export`,
    payload: {
      key: `${componentName}@export`,
      apiParams: {}
    }
  }
}


let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
}

export { reduxTemplateCofig, templateConfig }
